import { ConfirmModal } from '@controlrooms/components';

export const ConfirmDeleteModal = ({ onConfirm }: { onConfirm: (closeState: boolean) => void }) => {
  return (
    <ConfirmModal
      open={true}
      title="Confirm to delete"
      message="Are you sure you want to delete?"
      confirmText="Delete"
      cancelText="Cancel"
      onConfirm={() => onConfirm(true)}
      onCancel={() => onConfirm(false)}
      size="sm"
    />
  );
};
